import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/recommendations');
  return response.data.data;
}

export default {
  index,
};
